import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { defaultStoreDTO } from '@utils/store';

import { TDefaultStoreDTO } from '@interfaces/common/store';
import { IError } from '@interfaces/errors/apiErrors';

import { defaultMeta } from '@enums/common';
import { TErrorCodes } from '@enums/errorCodes';

import { responseMessages } from '@constants/responseMessages';

interface IInitialState extends TDefaultStoreDTO {
	errorsList: Record<string | TErrorCodes, IError>;
}

const DEFAULT_ERROR = 'default_error';

const initialState: IInitialState = {
	...defaultMeta,
	sortDirection: false,
	sortFieldName: null,
	searchValue: '',
	errorsList: {
		[DEFAULT_ERROR]: { message: responseMessages.error, code: DEFAULT_ERROR },
	},
};

const common = createSlice({
	name: 'errors',
	initialState,
	reducers: {
		...defaultStoreDTO,
		setErrors: (state, action: PayloadAction<{
			errors: Record<string, IError>;
		}>) => {
			state.errorsList = {
				...initialState.errorsList,
				...action.payload.errors,
			};
		},
		resetErrorCodesTable: (state) => {
			return {
				...initialState,
				errorsList: state.errorsList,
			};
		},
	},
});

export const {
	setErrors,
	setPage,
	setPageSize,
	setSort,
	setSearchValue,
	resetErrorCodesTable,
} = common.actions;

export default common.reducer;
